<template>
  <WithTopAndBottom class="home">
    <TopHeader />

    <SwipeList :list="bigBanner" v-if="bigBanner.length" />

    <SmallBaners :list="smallBanner" v-if="smallBanner.length" />

    <!-- <ScrollActivityList v-if="activityList.length" :list="activityList" /> -->

    <van-notice-bar
      v-if="notice.length"
      class="m-[8px_16px_0] rounded-8"
      background="#FFFFFF0D"
      color="#FFFFFF"
      :text="noticeText"
      :left-icon="xiaoxi"
    />

    <ScrollGameCatesList />

    <GameCategary
      v-for="category in categories"
      :key="category.id"
      :categary="category"
    />

    <Footer />

    <!-- 电话验证 -->
    <!-- <PhoneVerify /> -->

    <!-- 活动奖励弹框 -->
    <ActivityPopupTips v-if="isLoggedIn" />

    <!-- 奖金弹框 -->
    <BonusPopupTips v-if="isLoggedIn" />

    <!-- 引导安装 -->
    <GuideInstallWithServico />

    <!-- 弹框图片 -->
    <PopupImgs :items="popupImages" v-if="popupImages.length" />

    <!-- 左侧悬浮图标 -->
    <FloatingImg />

    <!-- 底部安装 -->
    <BottomInstallBar />
  </WithTopAndBottom>
</template>

<script setup lang="tsx">
import TopHeader from "./topHeader.vue";
import Footer from "./footer.vue";
import SwipeList from "./swipeList.vue";
import xiaoxi from "@a/views/Home/images/xiaoxi.png";
import ScrollGameCatesList from "./scrollGameCatesList.vue";
import GameCategary from "./gameCategary.vue";
// import PhoneVerify from './phoneVerify.vue'
import WithTopAndBottom from "@a/layouts/withTopAndBottom.vue";
import ActivityPopupTips from "./activityPopupTips.vue";
import BonusPopupTips from "./bonusPopupTips.vue";
import {
  useHomeBannersAndTexts,
  useGameCategory,
  useUserInfo,
} from "@/store";
import GuideInstallWithServico from "./guideInstallWithServico.vue";
import BottomInstallBar from "./bottomInstallBar.vue";
import SmallBaners from "./smallBaners.vue";
import PopupImgs from "./popupImgs.vue";
import FloatingImg from "./floatingImg.vue";
import debounce from 'lodash-es/debounce'

delete sessionStorage.showSideBar;
delete sessionStorage.deactivated;

const isLoggedIn = computed(() => useUserInfo().isLoggedin);

defineOptions({
  name: "home",
});

const bigBanner = computed(() => useHomeBannersAndTexts().bigBanner);
const smallBanner = computed(() => useHomeBannersAndTexts().smallBanner);
const notice = computed(() => useHomeBannersAndTexts().carouselMessage);
const noticeText = computed(() => notice.value.map((item) => item.rotationContent).join(" "));
const popupImages = computed(() =>
  useHomeBannersAndTexts().popupImage.filter((item) => item.state === "Enabled")
);

const categories = computed(() => useGameCategory().leftList);

let scrollY = 0
const recordScrollY = debounce(() => {
  scrollY = document.documentElement.scrollTop || 0
}, 100, { leading: true })

onActivated(() => {
  window.addEventListener('scroll', recordScrollY)
  document.documentElement.scrollTop = scrollY
})

onDeactivated(() => {
  window.removeEventListener('scroll', recordScrollY)
})
</script>

<style lang="scss" scoped>
.home {
  --van-notice-bar-icon-size: 24px;
  --van-notice-bar-icon-min-width: 28px;
  --van-popup-background: transparent;

  --theme-border-color: #a4c900;

  // padding-top: 0;
}
</style>
